import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { notification } from 'antd'

import { disputeTokenService } from '../../../services/directorServices'

const DisputeRespond = ({ dispute, onClose }) => {
    const [token, setToken] = useState('')
    const [tokenLoading, setTokenLoading] = useState(false)
    const disputeRef = useRef(null)

    // One token per dispute, fetched only when it is opened: the API refuses any dispute that is
    // not on this camp's bookings, so the id sent here is checked server-side.
    const openDispute = () => {
        if (!dispute?.id || tokenLoading) return

        setTokenLoading(true)
        disputeTokenService({ disputeId: dispute.id }).then(res => {
            if (res?.data?.statusCode) {
                setToken(res.data.responseData.accessToken)
            } else {
                notification.open({ message: res?.data?.error?.responseMessage || 'Could not open this dispute' })
            }
        }).catch(() => {
            notification.open({ message: 'Could not open this dispute' })
        }).finally(() => setTokenLoading(false))
    }

    // The component talks to Justifi directly, so a submitted response never passes through our
    // API. Let the caller refresh on close and the dispute webhook update our copy.
    const handleClose = () => {
        setToken('')
        if (onClose) onClose()
    }

    useEffect(() => {
        const disputeElement = disputeRef.current
        if (!disputeElement) return

        const onError = (event) => {
            notification.open({ message: event?.detail?.error || 'Justifi reported a problem with this dispute' })
        }

        disputeElement.addEventListener('error-event', onError)
        return () => disputeElement.removeEventListener('error-event', onError)
    }, [token])

    if (!dispute?.id) return ''

    return (
        <>
            <span className={`btn btn-primary btn-sm ${tokenLoading ? 'disabled' : ''}`} onClick={openDispute}>
                {tokenLoading ? 'Opening...' : 'View / Respond'}
            </span>

            <Modal
                show={!!token}
                animation={false}
                dialogClassName="payment_modal"
                size="lg"
                centered
            >
                <Modal.Body>
                    <span className="modal_close" onClick={handleClose}><i className="icon-cross" /></span>

                    {token ? (
                        <justifi-dispute-management
                            ref={disputeRef}
                            dispute-id={dispute.id}
                            auth-token={token} />
                    ) : ''}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DisputeRespond
